// extracted by mini-css-extract-plugin
module.exports = {"bookmark":"Bookmark_bookmark__2R3iA","bookmarkIcon":"Bookmark_bookmarkIcon__1BmiJ"};